// logging.ts
import { AsyncLocalStorage } from "async_hooks";
import pino from "pino";
import { inspect } from "util";
import { baseConfig } from "@adornis/config/baseConfig.js";
import { Environment } from "@adornis/config/environment-checks.js";
var baseLoggerOptions = {
  level: baseConfig.get("LOG_LEVEL")
};
var loggerStore = AsyncLocalStorage ? new AsyncLocalStorage() : void 0;
var loggerProxyHandler;
var clientChildProxy;
var clientTransmit;
var consoleLevelMap = {
  fatal: { func: console.error, color: "" },
  error: { func: console.error, color: "" },
  warn: { func: console.warn, color: "" },
  info: { func: console.log, color: "" },
  debug: { func: console.debug, color: "lightblue" },
  trace: { func: console.trace, color: "lightgray" }
};
if (baseConfig.get("ENVIRONMENT") === "node") {
  loggerProxyHandler = {
    get(target, property, receiver) {
      target = loggerStore?.getStore()?.get("logger") ?? target;
      return Reflect.get(target, property, receiver);
    }
  };
} else {
  baseLoggerOptions.browser = {
    // asObject: true
    // TODO
    transmit: {
      level: "error",
      send: (level, logEvent) => {
        if (logEvent.bindings.concat(logEvent.messages).some((thing) => thing?.[ignoreSymbol]))
          return;
        clientTransmit?.(level, logEvent);
      }
    },
    write: (objects) => {
      const label = pino.levels.labels[objects.level];
      const msg = objects.msg || objects.stack;
      delete objects.time;
      delete objects.level;
      delete objects.msg;
      delete objects.stack;
      const log = consoleLevelMap[label];
      log.func(`%c${label}: ${msg}`, `color: ${log.color || "inherit"}`, objects);
    }
  };
  loggerProxyHandler = {
    get(target, property, receiver) {
      target = clientChildProxy ?? target;
      return Reflect.get(target, property, receiver);
    }
  };
}
var baseLogger = pino(baseLoggerOptions);
var ignoreSymbol = Symbol("ignoreLog");
var logger = new Proxy(baseLogger, loggerProxyHandler);
var getChildLogger = (bindings) => baseLogger.child(bindings);
var setClientChildLogger = (bindings) => {
  clientChildProxy = baseLogger.child(bindings);
};
var setClientTransmit = (send) => {
  clientTransmit = send;
};
var replaceConsoleFunctions = () => {
  globalThis.baseLogger = baseLogger;
  const isNode = baseConfig.get("ENVIRONMENT") === Environment.NODE;
  if ([Environment.BROWSER, Environment.SERVICEWORKER].includes(baseConfig.get("ENVIRONMENT"))) {
    window.addEventListener("unhandledrejection", (e) => e.reason?.[ignoreSymbol] || logger.error(e.reason));
    window.addEventListener("error", (e) => e.error?.[ignoreSymbol] || logger.error(e.error));
  }
  console.debug = function(...args) {
    isNode ? logger.debug("legacy console.debug: " + args.map((a) => inspect(a)).join(" ")) : logger.debug(args[0], ...args.slice(1));
  };
  console.log = function(...args) {
    isNode ? logger.info("legacy console.log: " + args.map((a) => inspect(a)).join(" ")) : logger.info(args[0], ...args.slice(1));
  };
  console.warn = function(...args) {
    isNode ? logger.warn("legacy console.warn: " + args.map((a) => inspect(a)).join(" ")) : logger.warn(args[0], ...args.slice(1));
  };
  console.error = function(...args) {
    isNode ? logger.error("legacy console.error: " + args.map((a) => inspect(a)).join(" ")) : logger.error(args[0], ...args.slice(1));
  };
};
export {
  getChildLogger,
  ignoreSymbol,
  logger,
  loggerStore,
  replaceConsoleFunctions,
  setClientChildLogger,
  setClientTransmit
};
